module.exports = __webpack_public_path__ + "fonts/VetoSans-Light_3.9bb5f691.ttf";